import axios from 'axios';


export default {
    getAlerts() {
        var options = {
            url: window.apiUrl + '/weekly-updates',
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;
        });
    },
    submit(update) {
        var options = {
            url: window.apiUrl + '/weekly-update',
            method: 'POST',
            data: { update: update },
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;
        });
    },
}



// WEBPACK FOOTER //
// ./src/services/weekly-updates/index.js